module.exports = __webpack_public_path__ + "img/nodata.f14c977d.png";